import { useEffect } from "react";

const LivetecsAIWidget = () => {
    useEffect(() => {
        const script = document.createElement("script");
        //script.src = "http://124.29.238.222:89/api/livetecsai/widgets/dev.js";
        script.src = "https://timelive-ai.livetecs.com/api/livetecsai/widgets/dev.js";
        script.async = true;
        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    }, []);
    return null;
};

export default LivetecsAIWidget;